var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowRightShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46967 13.0303C5.17678 12.7374 5.17678 12.2626 5.46967 11.9697L9.43934 8L5.46967 4.03033C5.17678 3.73744 5.17678 3.26256 5.46967 2.96967C5.76256 2.67678 6.23744 2.67678 6.53033 2.96967L11.0303 7.46967C11.3232 7.76256 11.3232 8.23744 11.0303 8.53033L6.53033 13.0303C6.23744 13.3232 5.76256 13.3232 5.46967 13.0303Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightShort);
export default __webpack_public_path__ + "static/media/icon-arrow-right-short.71cd3a9b5e7cb3919d2de2208f84b829.svg";
export { ForwardRef as ReactComponent };